var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGlobeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.973 2.678a.333.333 0 0 0-.561.108l-.738 2.042c-.18.45-.59.766-1.07.826H9.716a.333.333 0 0 0-.256.48l.589 1.516a.333.333 0 0 0 .297.184h.551a.333.333 0 0 1 .298.481l-1.847 3.786a1.348 1.348 0 0 1-2.572-.165l-.66-2.772a.333.333 0 0 0-.297-.184h-.296a2.162 2.162 0 0 1 0-4.324h2.728a.333.333 0 0 0 .332-.332V3.56a1.33 1.33 0 0 0-.831-1.233l-.19-.076a.333.333 0 0 1-.041-.598L9.33.722a.333.333 0 0 0-.1-.624A7.748 7.748 0 0 0 8.018 0a8 8 0 1 0 5.955 2.678z",
    fill: "#8B909A",
    fillRule: "nonzero"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobeIcon);
export default __webpack_public_path__ + "static/media/globe-icon.75d85446653ccd405b6af2952e0ab79c.svg";
export { ForwardRef as ReactComponent };